module.exports = __webpack_public_path__ + "img/nav_6.18cb7764.png";